<template>
    <div class="embed-icon">
        <img class="icon" src="../assets/image/icon/icon_contact.png" @click="showContact()">
        <img class="icon-m" src="../assets/image/icon/icon_contact_m.png" @click="goContact()">
    </div>

</template>
<script>
export default {
    methods: {
        showContact() {
            this.$emit('show-contact')
        },
        goContact() {
            window.location.href = '/#/contactUs'
        }
    }
}
</script>
<style scoped>
.embed-icon {
    top: 85%;
    right: 0.2rem;
    transform: translateY(-50%);
    position: fixed;
}

.icon-m {
    display: none;
}

.icon {
    display: block;
    width: 1.17rem;
    height: auto;
    cursor: pointer;
}

@media (max-width: 1200px) {

    .embed-icon {
        right: 0.105rem;
        top: 70%;
    }

    .icon {
        display: none;
    }

    .icon-m {
        display: block;
        width: 0.59rem;
        height: 0.59rem;
        cursor: pointer;
    }
}

</style>